import { User } from '../authentication/model/user.model';
import { Action, createReducer, on } from '@ngrx/store';
import { UserManagementActions } from './user-management.actions';
import { TableResponse } from '../../models/table/table-response.model';

export const userManagementFeatureKey = 'userManagement';

export interface State {
    selectedUsers: TableResponse<User>;
    loadedUsers: TableResponse<User>;
    showSelectedUser: boolean;
}

export const initialState: State = {
    showSelectedUser: false,
    selectedUsers: {
        data: [],
        totalRecords: 0
    },
    loadedUsers: {
        data: [],
        totalRecords: 0
    }
};

export const getShowSelectedUsers = (state: State) => state.showSelectedUser;
export const getSelectedUsers = (state: State) => state.selectedUsers;

const userManagementReducer = createReducer(
    initialState,
    on(UserManagementActions.updateAllSelectedUsers, (state, { users }) => {
        // if all users are unselected make sure loaded users are shown
        return {
            ...state,
            selectedUsers: {
                ...state.selectedUsers,
                data: users,
                totalRecords: users.length
            },
            showSelectedUser: users.length < 1 ? false : state.showSelectedUser
        };
    }),
    on(UserManagementActions.updateUserSuccess, (state, { updatedUser }) => {
        return {
            ...state,
            loadedUsers: {
                ...state.loadedUsers,
                data: state.loadedUsers.data.map((user) => (user.id === updatedUser.id ? { ...user, ...updatedUser } : user))
            },
            selectedUsers: {
                ...state.selectedUsers,
                data: state.selectedUsers.data.map((user) => (user.id === updatedUser.id ? { ...user, ...updatedUser } : user))
            }
        };
    }),
    on(UserManagementActions.updateUserFailure, (state) => {
        return {
            ...state
        };
    }),
    on(UserManagementActions.loadUsersSuccess, (state, { response }) => {
        return {
            ...state,
            loadedUsers: response
        };
    }),
    on(UserManagementActions.createUserSuccess, (state, { newUser }) => {
        return {
            ...state,
            loadedUsers: {
                ...state.loadedUsers,
                data: [newUser, ...state.loadedUsers.data],
                totalRecords: state.selectedUsers.totalRecords + 1
            },
            selectedUsers: {
                ...state.selectedUsers,
                data: [newUser, ...state.selectedUsers.data],
                totalRecords: state.selectedUsers.totalRecords + 1
            }
        };
    }),
    on(UserManagementActions.createUserFailure, (state) => {
        return {
            ...state
        };
    }),
    on(UserManagementActions.changeUserTableData, (state) => {
        return {
            ...state,
            showSelectedUser: !state.showSelectedUser
        };
    }),
    on(UserManagementActions.deleteUserSuccess, (state, { userIds }) => {
        return {
            ...state,
            loadedUsers: {
                ...state.loadedUsers,
                data: state.loadedUsers.data.filter((user) => !userIds.includes(user.id!)),
                totalRecords: state.loadedUsers.totalRecords - userIds.length
            },
            selectedUsers: {
                ...state.selectedUsers,
                data: state.selectedUsers.data.filter((user) => !userIds.includes(user.id!)),
                totalRecords: state.selectedUsers.totalRecords - userIds.length
            }
        };
    }),
    on(UserManagementActions.removeSelectedUser, (state, { userToRemove }) => {
        return {
            ...state,
            selectedUsers: {
                ...state.selectedUsers,
                data: state.selectedUsers.data.filter((user) => userToRemove.id !== user.id),
                totalRecords: state.selectedUsers.totalRecords - 1
            }
        };
    })
);

export function reducer(state: State | undefined, action: Action) {
    return userManagementReducer(state, action);
}
